module.exports = __webpack_public_path__ + "img/cpInitialize.60476473.svg";